!function() {
  "use strict";

  class TruncatableContent extends HTMLElement {
    constructor() {
      super();
      this.expandClickHandler = this.expandClickHandler.bind(this);
      this.shrinkClickHandler = this.shrinkClickHandler.bind(this);
    }

    connectedCallback() {
      this.truncatable = this.querySelector(".truncatable-content");
      this.expand = this.querySelector(".expand");
      this.shrink = this.querySelector(".shrink");

      if (this.truncatable && this.expand && this.shrink) {
        this.hideParagraphs(); // Initial state
        this.truncatable.style.maxHeight = "none"; // Ensure natural height by default
        this.renderExpandShrink();
      }
    }

    hideParagraphs() {
      this.querySelectorAll(".truncatable-content p").forEach(p => {
        p.style.display = "none";
      });

      this.truncatable.style.maxHeight = null; // Remove height restriction if added
      this.truncatable.style.overflow = "hidden";
    }

    showParagraphs() {
      this.querySelectorAll(".truncatable-content p").forEach(p => {
        p.style.display = "block";
      });

      this.truncatable.style.maxHeight = "none"; // Let it fully expand
      this.truncatable.style.overflow = "visible";
    }

    expandClickHandler(e) {
      e.preventDefault();
      e.stopPropagation();
      this.classList.add("expanded");
      this.showParagraphs();
      this.expand.style.display = "none";
      this.shrink.style.display = "inline";
    }

    shrinkClickHandler(e) {
      e.preventDefault();
      e.stopPropagation();
      this.classList.remove("expanded");
      this.hideParagraphs();
      this.expand.style.display = "inline";
      this.shrink.style.display = "none";
    }

    renderExpandShrink() {
      this.classList.add("truncated");
      this.expand.addEventListener("click", this.expandClickHandler);
      this.shrink.addEventListener("click", this.shrinkClickHandler);
      this.shrink.style.display = "none"; // Initial state
    }

    disconnectedCallback() {
      this.expand.removeEventListener("click", this.expandClickHandler);
      this.shrink.removeEventListener("click", this.shrinkClickHandler);
    }
  }

  if (!customElements.get("truncatable-content")) {
    customElements.define("truncatable-content", TruncatableContent);
  }
}();